// @flow
import * as React from 'react';
import Modal from 'components/Modal';

const KBD = props => (
  <kbd
    className="fw9 bg-light-gray ph2 pv1 br1 ml1 ba b--moon-gray"
    style={{ boxShadow: 'inset 0 -1px #aaa' }}
  >
    {props.children}
  </kbd>
);

export type ShortcutMenuItem = [string | string[], string];

type Props = {
  items: Array<ShortcutMenuItem>,
  onClose: () => void,
};

export default class KeyboardShortcutsMenu extends React.PureComponent<
  Props,
  void
> {
  render() {
    return (
      <Modal onClose={this.props.onClose}>
        <Modal.Header>Keyboard shortcuts</Modal.Header>
        <Modal.Body>
          <table className="collapse dark-gray ma4">
            <tbody>
              {this.props.items.map(item => {
                const [keys, action] = item;
                const kbds = Array.isArray(keys) ? (
                  keys.map(k => <KBD key={k}>{k}</KBD>)
                ) : (
                  <KBD>{keys}</KBD>
                );

                return (
                  <tr key={action}>
                    <td className="tr pa2">{kbds}</td>
                    <td className="pa2">{action}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </Modal.Body>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ModerationCard/PowerReviewsModerationCard/KeyboardHelperMenu.js